module.exports = __webpack_public_path__ + "static/media/nfchova.09f83deb.png";